import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React, { useState } from "react";
import RichTextEditor from "../../../components/Content/RichTextEditor";
import { CustomInput } from "../../../components/Common/CustomInputs";
import CustomTagInput from "../../../components/Common/CustomTagInput";
import { CustomDropdown } from "../../../components/Common/CustomDropdown";
import { groupsData } from "../../../assets/data/data";
import LinkBox from "../../../components/Content/LinkBox";
import axiosInstance from "../../../utils/config/config";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { useDispatch } from "react-redux";
import { getAllLessons } from "../../../redux/actions/lessons.dispatcher";

const CreateLessons = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: [],
    heading: "",
    content: "",
    lessonNumber: null,
    groupId: null,
  });

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  const [success, setsuccess] = useState(false);

  const handleSave = async () => {
    setErrorState({ error: false, message: "" });

    if (
      formData.title.length === 0 ||
      formData.heading.trim() === "" ||
      formData.content.trim() === "" ||
      formData.lessonNumber === null ||
      formData.groupId === null
    ) {
      console.log("Please fill all the fields");
      setErrorState({
        error: true,
        message: "Please fill all the fields",
      });
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/courselessons/create",
        formData
      );

      if (response.status === 200) {
        console.log("Lesson created successfully");
        setsuccess(true);
        setFormData({
          title: [],
          heading: "",
          content: "",
          lessonNumber: null,
          groupId: null,
        });
        dispatch(getAllLessons());
      }
    } catch (error) {
      console.log(error, "erro");
      setErrorState({
        error: true,
        message: error.response.data.error,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mt: 4,
      }}
    >
      <CustomInput
        label="Heading"
        placeholder="Enter the heading of the lesson"
        value={formData.heading}
        setValue={(value) => setFormData({ ...formData, heading: value })}
        noIcon
        color={"#fff"}
        bR={4}
        width={"100%"}
      />

      <CustomTagInput
        label={"Title"}
        hashTags={formData.title}
        setHashTags={(value) => setFormData({ ...formData, title: value })}
        color={"#fff"}
      />

      <CustomInput
        label="Lesson Number"
        placeholder="Enter the lesson number of the lesson"
        value={formData.lessonNumber}
        setValue={(value) => setFormData({ ...formData, lessonNumber: value })}
        noIcon
        color={"#fff"}
        bR={4}
        width={"100%"}
        type={"number"}
      />

      <CustomDropdown
        label="Group"
        value={formData.groupId}
        setValue={(value) => setFormData({ ...formData, groupId: value })}
        data={groupsData}
        color={"#fff"}
        noIcon
      />

      <Typography
        sx={{
          fontFamily: "'Quicksand', sans-serif",
          fontSize: "14px",
          color: "#fff",
          fontWeight: "800",
          mb: 1,
          mt: 2,
          textTransform: "uppercase",
          textAlign: "left",
        }}
      >
        Content
      </Typography>
      <RichTextEditor formData={formData} setFormData={setFormData} />

      <Box sx={{ mt: 2 }}>
        <LinkBox title={"Create Lesson"} onClick={handleSave} />
      </Box>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setsuccess(false)}
        text={"Data saved successfully"}
      />
    </Box>
  );
};

export default CreateLessons;
